import { BrandKit, VoiceParams } from 'types'
import { BrandVoiceEditable } from './BrandVoiceEditable'
import { useMemo } from 'react'

type Props = {
  brandKit: BrandKit
  voiceParams?: VoiceParams
  onVoiceUpdate?: (voice: VoiceParams) => void
  isOnboarding?: boolean
}

export const BrandVoice = ({ brandKit, voiceParams: voiceParamsProp, onVoiceUpdate, isOnboarding }: Props) => {
  const voiceParams = useMemo(() => {
    return (
      voiceParamsProp ??
      brandKit.brand_voice?.voice_params ??
      ({
        name: `${brandKit.name} Brand Voice`,
      } as Partial<VoiceParams>)
    )
  }, [voiceParamsProp, brandKit.brand_voice?.voice_params, brandKit.name])

  return (
    <BrandVoiceEditable
      brandKit={brandKit}
      onVoiceUpdate={onVoiceUpdate}
      isOnboarding={isOnboarding}
      initialVoiceParams={voiceParams}
    />
  )
}
